import { put, takeLatest } from "redux-saga/effects";
import { getOrderHistoryDetailApi } from "store/api/OrderApi";
import { GET_ORDER_HISTORY_DETAIL_ACTION } from "../../actions/OrderPageAction/actionTypes";

import * as orderPageAction from "../../actions/OrderPageAction";
import * as globalAction from "../../actions/GlobalAction";

function* errorMessage(message) {
	const alert = { isError: true, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* getOrderHistoryDetail(action) {
	yield put(globalAction.openLoadingPage());
	const res = yield getOrderHistoryDetailApi(action.params);
	try {
		if (res?.code === 0) {
			yield put(orderPageAction.setOrderHistoryDetailsAction(res?.data));
		} else {
			yield errorMessage(res?.message);
		}
	} catch (e) {
		console.log(e);
	} finally {
		yield put(globalAction.closeLoadingPage());
	}
}

function* getOrderHistoryDetailSaga() {
	yield takeLatest(GET_ORDER_HISTORY_DETAIL_ACTION, getOrderHistoryDetail);
}

export default getOrderHistoryDetailSaga;
